import { ElectronApi } from '@/services/electron.api';
import mediaInfoFactory from 'mediainfo.js';

/**
 * 获取video dom
 * @param realpath相对路径
 * @param base64图片信息
 */
export async function loadVideoDom(
  filename: string
): Promise<HTMLVideoElement | undefined> {
  const buffer = await ElectronApi.fs?.promises.readFile(filename);
  const ab = buffer?.buffer;
  if (!ab) return;
  let src = '';
  try {
    const blob = new Blob([ab]);
    const video = document.createElement('video');
    src = URL.createObjectURL(blob ?? '');
    video.src = src;
    // URL.revokeObjectURL(video.src);
    return video;
  } catch (error) {
    console.log(error);
  } finally {
    // if (src) URL.revokeObjectURL(src);
  }
}

/**
 * 获取视频文件的元数据
 * @param videoSrc
 * @returns
 */
export const getVideoData = async (
  videoSrc: string
): Promise<
  { poster: string; videoWidth: number; videoHeight: number } | undefined
> => {
  const videoEl = await loadVideoDom(videoSrc);
  if (!videoEl) return;
  videoEl.muted = true;
  videoEl.autoplay = true;
  videoEl.play();
  const canvas = document.createElement('canvas');
  return new Promise((resovle, reject) => {
    videoEl.onloadeddata = () => {
      const { videoWidth, videoHeight } = videoEl;
      canvas.width = videoWidth;
      canvas.height = videoHeight;
      canvas.getContext('2d')?.drawImage(videoEl, 0, 0);
      const dataUrl = canvas.toDataURL();
      resovle({
        poster: dataUrl,
        videoWidth,
        videoHeight
      });
    };
    videoEl.onerror = () => {
      reject();
    };
  });
};

export const getMediainfo = async (filename: string) => {
  const { fs } = ElectronApi;
  if (!fs) return;
  const buffer = await fs.promises.readFile(filename);
  const blob = new Blob([buffer.buffer]);
  const file = new File([blob], filename);
  const mediainfo = await mediaInfoFactory({
    format: 'object',
    locateFile() {
      // 使用 public 下的本地文件，路径需与 BASE_URL 相匹配
      return `${import.meta.env.BASE_URL}libs/MediaInfoModule.wasm`;
    }
  });
  const res = await mediainfo
    .analyzeData(file.size, async (chunkSize, offset) => {
      return new Uint8Array(
        await file.slice(offset, offset + chunkSize).arrayBuffer()
      );
    })
    .then((r) => {
      return r.media?.track;
    });
  mediainfo.close();
  return res;
};
